module.exports = __webpack_public_path__ + "static/img/quanmin06_header.673016ec.png";